import vue from "vue";
import {getCountBoard} from '@/services/dataBoard'
import moment from 'moment'

const state = {
  time: {
    startTime: moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'),
    endTime: moment(new Date()).format('YYYY-MM-DD'),
    recentStartTime: moment(new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)).format('YYYY-MM-DD'),
    recentEndTime: moment(new Date()).format('YYYY-MM-DD'),
  },
  userVisitList: [],//用户访问数据

  countDataMap: [],//
  ipDataMap: [],//
  isFirstDayDataMap: [],//
  timeDataMap: [],//
  urlDataMap: [],//

};

const getters = {
  userVisit: () => state.userVisit,

  countDataMap: () => state.countDataMap,
  ipDataMap: () => state.ipDataMap,
  isFirstDayDataMap: () => state.isFirstDayDataMap,
  timeDataMap: () => state.timeDataMap,
  urlDataMap: () => state.urlDataMap,
  time: () => state.time,
};

const actions = {
  getCountBoard({commit, dispatch}, objc) {
    getCountBoard({...state.time}).then((res) => {
      if (res.code === 0 && res.data) {
        const {countDataMap, ipDataMap, isFirstDayDataMap, timeDataMap, urlDataMap} = res.data;

        commit('updateState', {state: 'countDataMap', update: countDataMap});
        commit('updateState', {state: 'ipDataMap', update: ipDataMap});
        commit('updateState', {state: 'isFirstDayDataMap', update: isFirstDayDataMap});
        commit('updateState', {state: 'timeDataMap', update: timeDataMap});
        commit('updateState', {state: 'urlDataMap', update: urlDataMap});
      }
    })
  },
};

const mutations = {
  updateState: (state, payload) => {
    vue.set(state, payload.state, payload.update);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}



// WEBPACK FOOTER //
// ./src/store/dataBoard/modules/dataBoard.js